const github = 'https://github.com/celo-org/celo-mondo';
export const links = {
  home: 'https://mondo.celo.org',
  discord: 'https://discord.gg/celo',
  github,
  bug: github + '/issues/new?assignees=&labels=&projects=&template=bug_report.md&title=',
  twitter: 'https://twitter.com/celo',
  docs: 'https://docs.celo.org',
  forum: 'https://forum.celo.org',
  governance: 'https://github.com/celo-org/governance',
  // Explorers
  blockscout: 'https://celo.blockscout.com',
  blockscoutApi: 'https://celo.blockscout.com/api',
  // Auto-activation
  upstash: 'https://qstash.upstash.io/v2/publish',
} as const;
